// Testimonials data
export const testimonials = [
    {
        id: 1,
        name: 'Rajesh Kumar',
        role: 'Contractor',
        company: 'RK Constructions',
        rating: 5,
        text: 'SN Enterprises has been our go-to supplier for Astral pipes for over 3 years. Their genuine products and prompt delivery have never let us down. Highly recommended for bulk orders!',
        avatar: 'RK',
    },
    {
        id: 2,
        name: 'Priya Sharma',
        role: 'Architect',
        company: 'Modern Designs Ltd',
        rating: 5,
        text: 'Quality products at competitive prices. The team at SN Enterprises is knowledgeable and always helps us select the right pipe specifications for our projects.',
        avatar: 'PS',
    },
    {
        id: 3,
        name: 'Amit Patel',
        role: 'Plumber',
        company: 'AP Plumbing Services',
        rating: 5,
        text: 'Genuine Astral products every time. As a plumber, I trust SN Enterprises for all my pipe and fitting needs. Great service and fair pricing.',
        avatar: 'AP',
    },
    {
        id: 4,
        name: 'Sunita Verma',
        role: 'Builder',
        company: 'Verma Developers',
        rating: 5,
        text: 'Excellent service! We order in bulk for our residential projects. SN Enterprises ensures timely delivery and the quality of Astral pipes is always top-notch.',
        avatar: 'SV',
    },
    {
        id: 5,
        name: 'Mohammed Ali',
        role: 'Retailer',
        company: 'Ali Hardware Store',
        rating: 5,
        text: 'Best wholesale rates for Astral pipes in the area. SN Enterprises is reliable and their customer support is exceptional. Been working with them for 5 years.',
        avatar: 'MA',
    },
    {
        id: 6,
        name: 'Deepak Singh',
        role: 'Civil Engineer',
        company: 'Singh Infrastructure',
        rating: 5,
        text: 'Professional team and authentic products. SN Enterprises understands the technical requirements and always provides the right solutions for our infrastructure projects.',
        avatar: 'DS',
    },
];
